import _get from 'lodash/get'
import _isEmpty from 'lodash/isEmpty'

import DateUtils from '../date/date'

export function isUserSessionValid(userAuth: UserAuth | object | null) {
  if (_isEmpty(userAuth)) {
    return false
  }

  const { expirationTime, refreshTokenExpirationTime } = userAuth as UserAuth
  const expiry = expirationTime || refreshTokenExpirationTime

  if (!DateUtils.isValid(expiry)) {
    return true
  }

  return DateUtils.parse(expiry) > DateUtils.now()
}

export function isAdminUser(user: UserAuth | User | null) {
  if (_isEmpty(user)) {
    return false
  }

  const userData = _get(user, 'user', user)

  const isSuperuser = _get(userData, 'isSuperuser', false)
  const isStaff = _get(userData, 'isStaff', false)

  return isSuperuser || isStaff
}
